// Create a custom hook for initializing Google Tag Manager
import { useEffect } from 'react';
// @ts-ignore
import TagManager from 'react-gtm-module';
import { ConfigHelper } from '@devxdiscover/devhub-common';

/**
 * A custom hook for initializing Google Tag Manager.
 */
const useGoogleTagManager = () => {
  const gtmId = ConfigHelper.instance.config.getOptionalString(
    'app.analytics.gtmId',
  );
  useEffect(() => {
    if (gtmId) {
      TagManager.initialize({ gtmId });
    }
  }, [gtmId]);
};

export default useGoogleTagManager;
